/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Rounds_Finish_Round_NInputs */



/**
* | output |
* | --- |
* | "Finish Round {n}" |
*
* @param {Rounds_Finish_Round_NInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_finish_round_n = /** @type {((inputs: Rounds_Finish_Round_NInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Finish_Round_NInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Terminer la ronde ${i?.n}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Finalizar ronda ${i?.n}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Concluir Rodada ${i?.n}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Termina Round ${i?.n}`)
	return /** @type {LocalizedString} */ (`Finish Round ${i?.n}`)
});